import React, { useState, useEffect } from "react";
import $ from "jquery";

import PlayersCriteria from "./PlayersCriteria";
import GameTypeCriteria from "./GameTypeCriteria";

import { callApi } from "../common/Apis";

export default function DefaultCriteria(props) {
    const [codes, setCodes] = useState();

    useEffect(() => {
        callApi(
            "/hiball/tmp/code/multi/criteria",
            props.criteria,
            configCriteriaHandler
        );
    }, [props.criteria.seasons, props.criteria.gameTypes]);

    const configCriteriaHandler = (response) => {
        let data = response.data;
        setCodes(data);
    };

    const changeHandler = (evt) => {
        let property = evt.target.name;
        let changedCriteria = { ...props.criteria };

        if (property === "seasons") {
            let beforeTeamId = changedCriteria.teamId;
            let beforePosition = changedCriteria.position;
            let beforeGameType = changedCriteria.gameTypes;

            changedCriteria = { ...props.criteria };
            changedCriteria.teamId = beforeTeamId;
            changedCriteria.position = beforePosition;

            changedCriteria.gameTypes = beforeGameType;

            changedCriteria[property] = [evt.target.value];
        } else {
            changedCriteria[property] = evt.target.value;
        }

        //해당 사즌, 경기유형, 포지션에 선수가 없을수도 있기 때문에 모두 초기화 해준다.
        changedCriteria.playerIds = [];
        changedCriteria.oppPlayerIds = [];
        changedCriteria.pitcherIds = [];
        changedCriteria.batterIds = [];

        props.setCriteria(changedCriteria);
    };

    const changeGameTypeHandler = (evt) => {
        //경기유형 change 이벤트 핸들러
        let property = evt.target.name;
        let changedCriteria = { ...props.criteria };

        //해당 사즌, 경기유형, 포지션에 선수가 없을수도 있기 때문에 모두 초기화 해준다.
        changedCriteria.playerIds = [];
        changedCriteria.oppPlayerIds = [];
        changedCriteria.pitcherIds = [];
        changedCriteria.batterIds = [];

        changedCriteria[property] = evt.target.value;

        props.setCriteria(changedCriteria);

        // console.log(changedCriteria);
        // console.log(property);
        // console.log(evt.target.value);
    }

    const changeTeamHandler = (evt) => {
        let property = evt.target.name;
        let changedCriteria = { ...props.criteria };

        if (property === "teamId") {
            if (changedCriteria.position === "batter") {
                //만약 우리팀을 바꿨을때 포지션이 타자라면
                changedCriteria.playerIds = [];
                changedCriteria.batterIds = [];
            } else if (changedCriteria.position === "pitcher") {
                //만약 우리팀을 바꿨을때 포지션이 투수라면
                changedCriteria.playerIds = [];
                changedCriteria.pitcherIds = [];
            }
        } else if (property === "oppTeamId") {
            if (changedCriteria.position === "batter") {
                //만약 상대팀을 바꿨을때 포지션이 타자라면
                changedCriteria.oppPlayerIds = [];
                changedCriteria.pitcherIds = [];
            } else if (changedCriteria.position === "pitcher") {
                //만약 상대팀을 바꿨을때 포지션이 투수라면
                changedCriteria.oppPlayerIds = [];
                changedCriteria.batterIds = [];
            }
        }

        changedCriteria[property] = evt.target.value;

        props.setCriteria(changedCriteria);
    };

    const playerChangeHandler = (evt) => {
        let property = evt.target.name;
        let changedCriteria = { ...props.criteria };

        changedCriteria[property] = evt.target.value;

        if (changedCriteria.position === "batter") {
            changedCriteria.batterIds = changedCriteria.playerIds;
            changedCriteria.pitcherIds = changedCriteria.oppPlayerIds;
        } else if (changedCriteria.position === "pitcher") {
            changedCriteria.pitcherIds = changedCriteria.playerIds;
            changedCriteria.batterIds = changedCriteria.oppPlayerIds;
        }

        props.setCriteria(changedCriteria);
    };

    const checkboxChangeHandler = (evt) => {
        let property = evt.target.name;
        let changedCriteria = { ...props.criteria };

        var isChecked = $("#" + property + "").is(":checked");

        changedCriteria[property] = isChecked;

        props.setCriteria(changedCriteria);
    };

    return (
        <>
            <div className="col-12 game-type">
                {/* <h5>
					<small data-lang="selectGameType">경기 유형 선택</small>
				</h5> */}
                <GameTypeCriteria
                    criteria={props.criteria}
                    changeHandler={changeHandler}
                    changeGameTypeHandler={changeGameTypeHandler}
                    useLang={props.useLang}
                />
            </div>
            <div className="col-12 team-type" style={{ marginTop: "20px" }}>
                {/* <h5>
					<small data-lang="selectTeamNPlayer">팀 및 선수 선택</small>
				</h5> */}
                <PlayersCriteria
                    data={codes}
                    criteria={props.criteria}
                    setCriteria={props.setCriteria}
                    changeTeamHandler={changeTeamHandler}
                    playerChangeHandler={playerChangeHandler}
                    useLang={props.useLang}
                    // setWholePlayers={props.setWholePlayers}
                    // setOppWholePlayers={props.setOppWholePlayers}
                />
            </div>

            <div className="col-12" style={{ marginTop: "20px" }}>
                <div className="row">
                    <div
                        className="input-group"
                        style={{ width: "50%", flexWrap: "nowrap" }}
                    >
                        <div className="input-group-prepend">
                            <span
                                id="recent6G-title"
                                className="input-group-text custom-select-sm"
                                style={{ width: "90px" }}
                                data-lang="recent6G"
                            >
                                최근6경기
                            </span>
                        </div>
                        <div className="input-group-append">
                            <div
                                className="input-group-text custom-select-sm"
                                style={{
                                    width: "50px",
                                }}
                            >
                                <input
                                    id="latestGames"
                                    checked={props.criteria.latestGames}
                                    onChange={checkboxChangeHandler}
                                    name="latestGames"
                                    type="checkbox"
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        className="input-group"
                        style={{ width: "50%", flexWrap: "nowrap" }}
                    >
                        <div className="input-group-prepend">
                            <span
                                id="pickOffs-title"
                                className="input-group-text custom-select-sm"
                                style={{ width: "90px" }}
                                data-lang="pickOffs"
                            >
                                견제
                            </span>
                        </div>
                        <div className="input-group-append">
                            <div
                                className="input-group-text custom-select-sm"
                                style={{
                                    width: "50px",
                                }}
                            >
                                <input
                                    id="checkbase"
                                    checked={props.criteria.checkbase}
                                    onChange={checkboxChangeHandler}
                                    name="checkbase"
                                    type="checkbox"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
